export function articleTitle(value: unknown, untitled: string): string {
    return typeof value === 'string' && value.trim() ? value.trim() : untitled;
}
const normalized = (value: string) => value.replace(/\s+/g, ' ').trim();
export function articleLead(title: string, excerpt?: string | null, html = ''): string {
    const text = excerpt?.trim() || '';
    const firstParagraph = new DOMParser().parseFromString(html, 'text/html').body.querySelector('p')?.textContent || '';
    return !text || normalized(text) === normalized(title) || normalized(text) === normalized(firstParagraph) ? '' : text;
}
export function articleBody(outline: { html: string; headings: Array<{ id: string; title: string; level: number }> }, title: string) {
    const document = new DOMParser().parseFromString(outline.html, 'text/html');
    const first = document.body.firstElementChild;
    let removed = '';
    // Only a structurally leading title is redundant; keep all body paragraphs and anchors.
    if (first && /^H[1-6]$/.test(first.tagName) && normalized(first.textContent || '') === normalized(title)) {
        removed = first.id;
        const anchor = document.createElement('span'); anchor.id = first.id; anchor.className = 'article-title-anchor';
        first.replaceWith(anchor);
    }
    document.querySelectorAll('h1').forEach(heading => {
        const replacement = document.createElement('h2');
        for (const attribute of Array.from(heading.attributes)) replacement.setAttribute(attribute.name, attribute.value);
        replacement.innerHTML = heading.innerHTML; heading.replaceWith(replacement);
    });
    return { html: document.body.innerHTML, headings: outline.headings.filter(item => item.id !== removed).map(item => ({ ...item, level: Math.max(2, item.level) })) };
}
